import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Neighborhood2 from "./Neighborhood2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import codesoil1 from "../../Assets/code_soil1.jpg";
import codesoilplants1 from "../../Assets/code_soil_plants.jpeg";
import codesoil2 from "../../Assets/code_soil2.jpg";
import codesoil6 from "../../Assets/code_soil6.jpg";
import codesoilplants2 from "../../Assets/code_soil_plants2.jpeg";
import codesoil7 from "../../Assets/code_soil7.jpg";
import code_soil_plants3 from "../../Assets/code_soil_plants3.jpeg";
import codesoil8 from "../../Assets/code_soil8.jpg";



// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: codesoil1, alt: "code_soil" },
  { src: codesoilplants1, alt: "code_soil" },
  { src: codesoil2, alt: "code_soil" },  
  { src: codesoil6, alt: "code_soil" },
  { src: codesoilplants2, alt: "code_soil" }, 
  { src: codesoil7, alt: "code_soil" },
   { src: code_soil_plants3, alt: "code_soil" },
  { src: codesoil8, alt: "code_soil" },



  // Add more images as needed

  ];
console.log(sliderImages)


function Neighborhood() {

   const navigate = useNavigate(); // Initialize navigate
  
  
  
  const handleClick = () => {
    navigate("/registration#codesoil-section"); // This will navigate to the "/another-page" route
  };

  
 
  // Settings for the Slick slider
  const settings = {
    
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid"
                    style={{ objectFit: "cover", height: "60%", width: "100%" }}
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>

    

<Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  Register Now
</Button>


      
          <Neighborhood2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default Neighborhood;
